// extracted by mini-css-extract-plugin
export default {"web-office-modal":"web-office-modal___EQ9AO","pdfWrapper":"pdfWrapper___HpbJp","pdfPagination":"pdfPagination___qSpSK"};